import React from 'react'
import { Icon } from '~/types'
import { icons } from '~/utils'

export const AtSymbol: React.FunctionComponent<Icon.Props> = ({ mode = 'light', filled = false }) => {
  const color = icons.getIconColor(mode)

  return filled ? (
    <svg viewBox="0 0 20 20" width="12px" height="12px" fill={color} className="at-symbol">
      <path
        fillRule="evenodd"
        d="M14.243 5.757a6 6 0 10-.986 9.284 1 1 0 111.087 1.678A8 8 0 1118 10a3 3 0 01-4.8 2.401A4 4 0 1114 10a1 1 0 102 0c0-1.537-.586-3.07-1.757-4.243zM12 10a2 2 0 10-4 0 2 2 0 004 0z"
        clipRule="evenodd"
      ></path>
    </svg>
  ) : (
    <svg fill="none" width="12px" height="12px" viewBox="0 0 24 24" stroke={color} className="at-symbol">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M16 12a4 4 0 10-8 0 4 4 0 008 0zm0 0v1.5a2.5 2.5 0 005 0V12a9 9 0 10-9 9m4.5-1.206a8.959 8.959 0 01-4.5 1.207"
      ></path>
    </svg>
  )
}

export default AtSymbol
